import { chain, filter, get, keyBy, map, reduce } from "lodash"
import { sanitizePositionSet } from "gatherers/helpers"

export const TOTAL_RISK = "totalRisk"
export const SPECIFIC_RISK = "alphaRisk"
export const FACTORS_RISK = "factorsRisk"

const METRICS = {
  [TOTAL_RISK]: {
    label: "Total Risk",
    valueGetter: data => get(data, "data.model.simulation.risk.0.total"),
  },
  [SPECIFIC_RISK]: {
    label: "Specific Risk",
    valueGetter: data => get(data, "data.model.simulation.risk.0.attribution.summary.specific"),
  },
  [FACTORS_RISK]: {
    label: "Factors Risk",
    valueGetter: data => get(data, "data.model.simulation.risk.0.attribution.summary.factors"),
  },
}

const getQuery = (shouldUseIntradayQuery) => {
  const innerQuery = `
      risk {
        total
        attribution {
          summary {
            specific
            factors
          }
          factors {
            id
            name
            category
            value
          }
        }
      }
    `

  if (shouldUseIntradayQuery) {
    return `query ($modelId: String!, $positionSet: PositionSetInput!, $date: Date!, $batchId: Id) {
        model (id: $modelId) {
          simulation:intradaySimulation (positionSet: $positionSet, on: $date, batchId: $batchId) {
            ${innerQuery}
          }
        }
      }`
  }

  return `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $date: Date!) {
  model (id: $modelId) {
    simulation (positionSet: $positionSet, base: $base, from: $date, to: $date) {
      ${innerQuery}
    }
  }
}`
}

export function createRiskSingleDateQuery(modelId, positionSet, base, date, options = {}) {
  const { batchId, isIntradayMode } = options

  return {
    key: ["risk", "singleDate", modelId, positionSet, base, date, isIntradayMode, batchId],
    query: getQuery(isIntradayMode),
    variables: {
      modelId,
      positionSet: sanitizePositionSet(positionSet),
      base,
      date,
      batchId,
    },
    select: (data) => {
      if (options.metrics) {
        const values = map(options.metrics, metric => {
          const metricConfig = { ...METRICS[metric] }
          if (metric === TOTAL_RISK && options.isActive) {
            metricConfig.label = "Tracking Error"
          }
          return {
            ...metricConfig,
            id: metric,
            value: METRICS[metric].valueGetter(data),
          }
        })

        return {
          values: keyBy(values, "id"),
        }
      }

      const values = chain(data)
        .get("data.model.simulation.risk.0.attribution.factors")
        .thru(factors => {
          if (options.category) {
            return filter(factors, f => f.category === options.category)
          }
          return factors
        })
        .keyBy("id")
        .mapValues(({ id, name, value }) => ({
          id,
          label: name,
          value,
        }))
        .value()

      const summary = reduce(values, (acc, { value }) => acc + value, 0)

      return {
        summary,
        values,
      }
    },
  }
}
